import http from "./client"

interface IChatResponse {
  success: boolean,
  data: IChatResponseItem[],
}

export interface IChatResponseItem {
  id: number,
  name: string,
  image: string,
  email: string
}

/**
 * Список чатов
 */
async function chatsList(courseId: number | string, search?: string): Promise<IChatResponse> {
  const response = await http.get<IChatResponse>(`/api/chatroom/list?course_id=${courseId}&limit=24&page=1&by=remove${search ? `&search=${search}` : ''}`);
  return response.data
}

const chats = {
  chatsList
}

export default chats;